import React from 'react';
import FormControl from 'react-bootstrap/FormControl';
import { FaLock, FaUser } from 'react-icons/fa';
import Button from 'react-bootstrap/Button';

import './Login.css';

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {username: '', password: ''};
  }

  onChangeUsername = (event) => {
    this.setState({ ...this.state, username: event.target.value });
  }

  onChangePassword = (event) => {
    this.setState({ ...this.state, password: event.target.value });
  }

  onLoginClick = () => {
    this.props.validate(this.state.username, this.state.password);
  }

  render() {
    return (
      <fieldset>
        <div className="form-group">
          <div className="input-group input-group-lg">
            <span className="input-group-addon">
            <FaUser className="iconusers" />
            </span>
            <FormControl
              type="text"
              autoComplete="off"
              autoFocus="on"
              placeholder="Username"
              className="form-control"
              value={this.state.username}
              onChange={this.onChangeUsername} />
          </div>
        </div>
        <div className="form-group">
          <div className="input-group input-group-lg">
            <span className="input-group-addon">
            <FaLock className="iconusers" />
            </span>
            <FormControl
              type="password"
              autoComplete="off"
              autoFocus="on"
              placeholder="Password"
              className="form-control"
              value={this.state.password}
              onChange={this.onChangePassword} />
          </div>
        </div>
        <div className="form-group"></div>
        <div className="form-group">
          <Button
            className="btnsub btn btn-primary btn-lg btn-block"
            onClick={this.onLoginClick}>
            Login
          </Button>
        </div>
      </fieldset>    
    );
  }
}
export default Login;
